import type { RouteObject } from 'react-router-dom';
import { RequirePermission } from '../auth/guards';
import { AllReportsPage } from './AllReportsPage';
import { ApiDocsPage } from './ApiDocsPage';
import {
  CustomReportBuilderPage,
  CustomizeReportsPage,
  SavedReportsPage,
  ScheduledReportsPage,
} from './CustomReportsPages';
import { ReportPage } from './ReportPage';

/**
 * Reports (PC224): the All Reports catalogue (PC428) and one generic page per report, which
 * checks the report's own code. The API logs use the same page under their own menu entries.
 */
export const reportsRoutes: RouteObject[] = [
  {
    path: 'reports',
    element: (
      <RequirePermission code="PC428">
        <AllReportsPage />
      </RequirePermission>
    ),
  },
  {
    path: 'reports/customize',
    element: (
      <RequirePermission code="PC429">
        <CustomizeReportsPage />
      </RequirePermission>
    ),
  },
  // The builder checks PC429 and the code of the report it draws on.
  { path: 'reports/customize/:key', element: <CustomReportBuilderPage /> },
  {
    path: 'reports/saved',
    element: (
      <RequirePermission code="PC520">
        <SavedReportsPage />
      </RequirePermission>
    ),
  },
  {
    path: 'reports/scheduled',
    element: (
      <RequirePermission code="PC527">
        <ScheduledReportsPage />
      </RequirePermission>
    ),
  },
  { path: 'reports/:key', element: <ReportPage /> },
  {
    // The address must not start with /api: those requests go to the API, not to this app.
    path: 'rest-api-docs',
    element: (
      <RequirePermission code="PC806">
        <ApiDocsPage />
      </RequirePermission>
    ),
  },
  { path: 'logs/rest-api', element: <ReportPage reportKey="rest-api-log" /> },
  { path: 'logs/usps-api', element: <ReportPage reportKey="usps-api-log" /> },
];
